import { GoftinoUserPortable } from "@3gaam/shared/hooks/useGoftino";
import { useAppSelector } from "@3gaam/capp/src/store/hooks";

export const GetGoftinoUser =() =>{
  let goftinoUser: GoftinoUserPortable | null = null;
  const currentCounselor= useAppSelector((state) => state.consultee?.applicant?.Counselor);
  if (currentCounselor){
    goftinoUser = {
      FullName: currentCounselor.Fullname,
      Mobile: currentCounselor.Mobile
    }
  } 

  return goftinoUser;
}